import type { SavingSettingsDetailsCountryConfig } from './SavingSettingsDetailsConfig';

export const settingsDetails: SavingSettingsDetailsCountryConfig = {
    displayDisposableBalance: true,
    shouldDisplayIBANWithTooltip: true,
    averageSavings: {
        displayAccountOwner: true,
        displayIban: true,
        displaySlashedBBAN: true,
        displayBIC: true,
    },
    termDeposit: {
        displayAccountOwner: true,
        displayIban: true,
        displaySlashedBBAN: true,
        displayBIC: true,
    },
    passbook: {
        displayAccountOwner: true,
        displayIban: true,
        displaySlashedBBAN: true,
        displayBIC: true,
    },
};
